export const jobs = [
  [
    { year: 1992, firm_age: 'firms_age_above0', job_creation: -2558667 },
    { year: 1993, firm_age: 'firms_age_above0', job_creation: -1207752 },
    { year: 1994, firm_age: 'firms_age_above0', job_creation: -628253 },
    { year: 1995, firm_age: 'firms_age_above0', job_creation: 673320 },
    { year: 1996, firm_age: 'firms_age_above0', job_creation: -1319685 },
    { year: 1997, firm_age: 'firms_age_above0', job_creation: -11712 },
    { year: 1998, firm_age: 'firms_age_above0', job_creation: 359628 },
    { year: 1999, firm_age: 'firms_age_above0', job_creation: -473610 },
    { year: 2000, firm_age: 'firms_age_above0', job_creation: 549940 },
    { year: 2001, firm_age: 'firms_age_above0', job_creation: -1951757 },
    { year: 2002, firm_age: 'firms_age_above0', job_creation: -5928842 },
    { year: 2003, firm_age: 'firms_age_above0', job_creation: -1915418 },
    { year: 2004, firm_age: 'firms_age_above0', job_creation: -1260240 },
    { year: 2005, firm_age: 'firms_age_above0', job_creation: -1600315 },
    { year: 2006, firm_age: 'firms_age_above0', job_creation: 773009 },
    { year: 2007, firm_age: 'firms_age_above0', job_creation: -2109359 },
    { year: 2008, firm_age: 'firms_age_above0', job_creation: -2644334 },
    { year: 2009, firm_age: 'firms_age_above0', job_creation: -8339850 },
    { year: 2010, firm_age: 'firms_age_above0', job_creation: -4571579 },
    { year: 2011, firm_age: 'firms_age_above0', job_creation: -446925 },
    { year: 2012, firm_age: 'firms_age_above0', job_creation: 208935 },
    { year: 2013, firm_age: 'firms_age_above0', job_creation: 23114 },
    { year: 2014, firm_age: 'firms_age_above0', job_creation: 421602 },
    { year: 2015, firm_age: 'firms_age_above0', job_creation: 892132 },
    { year: 2016, firm_age: 'firms_age_above0', job_creation: 265086 },
    { year: 2017, firm_age: 'firms_age_above0', job_creation: -328744 },
    { year: 2018, firm_age: 'firms_age_above0', job_creation: -163130 },
    { year: 2019, firm_age: 'firms_age_above0', job_creation: -175457 }
  ],
  [
    { year: 1992, firm_age: 'firms_age_0', job_creation: 2580180 },
    { year: 1993, firm_age: 'firms_age_0', job_creation: 2667314 },
    { year: 1994, firm_age: 'firms_age_0', job_creation: 2779284 },
    { year: 1995, firm_age: 'firms_age_0', job_creation: 2929764 },
    { year: 1996, firm_age: 'firms_age_0', job_creation: 2833375 },
    { year: 1997, firm_age: 'firms_age_0', job_creation: 2883422 },
    { year: 1998, firm_age: 'firms_age_0', job_creation: 2857584 },
    { year: 1999, firm_age: 'firms_age_0', job_creation: 2589114 },
    { year: 2000, firm_age: 'firms_age_0', job_creation: 2671572 },
    { year: 2001, firm_age: 'firms_age_0', job_creation: 2463658 },
    { year: 2002, firm_age: 'firms_age_0', job_creation: 3024851 },
    { year: 2003, firm_age: 'firms_age_0', job_creation: 2606609 },
    { year: 2004, firm_age: 'firms_age_0', job_creation: 2734119 },
    { year: 2005, firm_age: 'firms_age_0', job_creation: 2852106 },
    { year: 2006, firm_age: 'firms_age_0', job_creation: 2864794 },
    { year: 2007, firm_age: 'firms_age_0', job_creation: 2622169 },
    { year: 2008, firm_age: 'firms_age_0', job_creation: 2457585 },
    { year: 2009, firm_age: 'firms_age_0', job_creation: 2142782 },
    { year: 2010, firm_age: 'firms_age_0', job_creation: 2197284 },
    { year: 2011, firm_age: 'firms_age_0', job_creation: 2036269 },
    { year: 2012, firm_age: 'firms_age_0', job_creation: 2193529 },
    { year: 2013, firm_age: 'firms_age_0', job_creation: 2114931 },
    { year: 2014, firm_age: 'firms_age_0', job_creation: 2244988 },
    { year: 2015, firm_age: 'firms_age_0', job_creation: 2244642 },
    { year: 2016, firm_age: 'firms_age_0', job_creation: 2255323 },
    { year: 2017, firm_age: 'firms_age_0', job_creation: 2248681 },
    { year: 2018, firm_age: 'firms_age_0', job_creation: 2354821 },
    { year: 2019, firm_age: 'firms_age_0', job_creation: 2415632 }
  ]
]
